
import commercialOperationOffer from '@/mixins/commercialOperationOffer'
import {
  countdownTarget,
  operationBannerPhase,
  operationClosingDay,
  operationCountdown,
  operationDay,
  operationRunning,
  twoDigits,
} from '@/utils/commercialOperation'

const CODES_RETRY_DELAY = 20000
const CODES_RETRIES = 6

const PHASE_CLASSES = {
  announcement: 'tw-bg-operation-yellow !tw-text-operation-black',
  open: 'tw-bg-operation-black !tw-text-white',
  last_hours: 'tw-bg-operation-red !tw-text-white',
}

export default {
  name: 'CommercialOperationBanner',
  mixins: [commercialOperationOffer],
  data() {
    return {
      prefix: 'components.commercialOperationBanner',
      codesRetries: 0,
      codesRetryTimer: null,
      codeClass:
        'tw-flex-none tw-rounded-[5px] tw-border-2 tw-border-solid tw-border-operation-yellow tw-bg-operation-night tw-px-1.5 tw-leading-5 md:tw-px-2 md:tw-leading-6 tw-text-operation-yellow',
    }
  },
  computed: {
    phase() {
      const phase = operationBannerPhase(this.operation, this.siteNow)
      return phase === 'announcement' || this.operationOffer ? phase : null
    },
    phaseClass() {
      return PHASE_CLASSES[this.phase]
    },
    awaitingCodes() {
      return (
        operationRunning(this.operation, this.siteNow) && !this.operation.codes
      )
    },
    parts() {
      return operationCountdown(
        countdownTarget(this.operation, this.phase),
        this.siteNow
      )
    },
    countdown() {
      return this.formatCountdown(true)
    },
    shortCountdown() {
      return this.formatCountdown(false)
    },
    hoursLeft() {
      return this.$t(`${this.prefix}.countdownHoursMinutes`, {
        hours: twoDigits(this.parts.totalHours),
        minutes: twoDigits(this.parts.minutes),
      })
    },
    longDay() {
      return operationDay(this.$i18n.locale, this.operation.opens_at)
    },
    shortDay() {
      return operationDay(this.$i18n.locale, this.operation.opens_at, 'short')
    },
    announcement() {
      return this.$t(`${this.prefix}.announcement`, {
        name: this.operation.name,
        day: this.longDay,
        countdown: this.countdown,
      })
    },
    endsAtMidnight() {
      const text = this.$t(`${this.prefix}.endsAtMidnight`, {
        day: operationClosingDay(
          this.$i18n.locale,
          this.operation.closes_at,
          'weekday'
        ),
      })
      return text.charAt(0).toLocaleUpperCase(this.$i18n.locale) + text.slice(1)
    },
    openText() {
      return this.$t(`${this.prefix}.openText`, {
        name: this.operation.name,
        discount: this.operationDiscount,
        code: this.operationOffer.code,
        countdown: this.countdown,
        note: this.operationBrandsNote,
      })
    },
    lastHoursText() {
      return this.$t(`${this.prefix}.lastHoursText`, {
        name: this.operation.name,
        ending: this.endsAtMidnight,
        countdown: this.hoursLeft,
        discount: this.operationDiscount,
        code: this.operationOffer.code,
      })
    },
  },
  watch: {
    awaitingCodes(awaiting) {
      if (awaiting) this.fetchOpenedOperation()
    },
  },
  beforeDestroy() {
    clearTimeout(this.codesRetryTimer)
  },
  methods: {
    async fetchOpenedOperation() {
      clearTimeout(this.codesRetryTimer)
      await this.$store.dispatch('setCommercialOperation', {
        preview: this.$config.clockPreview ? Math.round(this.siteNow) : null,
      })
      if (this.awaitingCodes && this.codesRetries < CODES_RETRIES) {
        this.codesRetries += 1
        this.codesRetryTimer = setTimeout(
          this.fetchOpenedOperation,
          CODES_RETRY_DELAY
        )
      }
    },
    formatCountdown(withMinutes) {
      const { days, hours, minutes } = this.parts
      if (days === 0) {
        return this.$t(`${this.prefix}.countdownHoursMinutes`, {
          hours: twoDigits(hours),
          minutes: twoDigits(minutes),
        })
      }
      return withMinutes
        ? this.$t(`${this.prefix}.countdownDaysHoursMinutes`, {
            days,
            hours: twoDigits(hours),
            minutes: twoDigits(minutes),
          })
        : this.$t(`${this.prefix}.countdownDaysHours`, {
            days,
            hours: twoDigits(hours),
          })
    },
    trackClick() {
      this.$trackOperationBannerClick?.(this.phase)
    },
  },
}
